<div class="fractions">
  <div class="header p-16 p-sm-24"
       fxLayout.gt-xs="row"
       fxLayoutAlign.gt-xs="space-between center" *ngIf="user">
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="logo" fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          dashboard
        </mat-icon>
        <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
          {{'FRACTIONS.TITLE_LIST' | translate}}
        </span>
      </div>
    </div>
    <div class="search-wrapper">
      <div class="search">
        <label for="name" class="mr-8">
          <mat-icon (click)="clearSearch()">{{searchFraction.value ? 'clear' : 'search'}}</mat-icon>
        </label>
        <input id="name" [formControl]="searchFraction" [placeholder]="'FRACTIONS.SEARCH_PLACEHOLDER' | translate">
      </div>
    </div>
  </div>

  <div class="fractions-content">
    <app-list-filters class="filters-container"
                      [filters]="['active']"
                      (listFilters)="getListFilters($event)">
    </app-list-filters>
    <div class="fractions-table">
      <mat-table
        matSort
        [dataSource]="dataSource"
        [matSortActive]="requestParams.sort"
        [matSortDirection]="requestParams.order"
        [@animateStaggerRemondis]="dataSource.length"
        [@.disabled]="disableAnimations"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FRACTIONS.NAME' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let fraction"> {{fraction.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>{{'FRACTIONS.DESC' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let fraction"> {{fraction.description}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef>{{'FRACTIONS.CODE' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let fraction"> {{fraction.code}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FRACTIONS.STATUSES.ACTIVE' | translate}}</mat-header-cell>
          <mat-cell *matCellDef="let fraction">
            <mat-icon [ngClass]="fraction.active && 'green-icon'">
              {{fraction.active ? 'check' : 'close'}}
            </mat-icon>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          class="fraction-row"
          *matRowDef="let fraction; columns: displayedColumns;"
          [@animateRemondis]="{value:'*',params:{y:'100%'}}"
          [id]="fraction.uuid"
          (click)="viewFraction(fraction.uuid)"
        >
        </mat-row>
      </mat-table>

      <h4 class="no-data" *ngIf="totalCount === 0">
        {{'SHARED.NO_DATA' | translate}}
      </h4>

      <div *ngIf="totalCount" class="paginator-container">
        <mat-paginator
          (page)="pageChange($event)"
          [pageSize]="requestParams.limit"
          [pageIndex]="(requestParams.page - 1)"
          [length]="totalCount"
          class="paginator-holder"
        ></mat-paginator>
      </div>
    </div>
  </div>
  <button mat-fab class="add-fraction-button"
          [@animate]="{value:'*', params:{delay:'300ms',scale:'.2'}}"
          [matTooltip]="'FRACTIONS.TITLE_ADD' | translate"
          matTooltipPosition="above"
          [attr.data-cy]="'fractionAdd'"
          (click)="addFraction()">
    <mat-icon>add</mat-icon>
  </button>
</div>

